export const handleVariableChange = (val, container) => {
  if (container.current && container.current.documentEditor) {
    const editor = container.current.documentEditor.editor;
    editor.insertText(val); // Insert the value where the cursor is located
  }
};

export const handleVariableChange2 = (val, container) => {
  if (!container.current) return;

  const editorRef = container.current.getEditorRef?.();
  const view = editorRef?.getView?.();

  if (!view) {
    console.warn("Editor view not ready");
    return;
  }

  const { state } = view;
  const { from, to } = state.selection;

  // Replace selection with the variable text, or insert at cursor
  const tr = state.tr.insertText(val, from, to);
  view.dispatch(tr);
  view.focus();
};
